module.exports = "https://assets.kunst-gegen-mauern.de/appassets/shared/kunstgegenmauern_50x50-326208f019ccdb8a5151a5e5adf715b7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/shared/kunstgegenmauern_50x50.png
// module id = 186
// module chunks = 3 4